module.exports = __webpack_public_path__ + "static/media/sign-up-background-company.376c676c.png";